import z from 'zod';
import {firestoreTimestampSchema} from '../_other/firestore/firestoreTimestampSchema';
import {tradeDirectionSchema} from './TradeDirection';
import {tradeStatusSchema} from './TradeStatus';
import {tradeMessageWriteSchema} from './tradeMessageWriteSchema';

export const tradeWriteSchema = z.object({
  /** like order id in broker, and 1, 2, 3 etc in replay */
  tradeId: z.string().min(1).optional(),
  /** datetime string of first trade in replay, manual in manual journaling */
  sessionId: z.string().min(1).optional(),
  symbol: z.string().min(1),
  entryPrice: z.number(),
  positionSize: z.number().optional(),
  exitPrice: z.number().optional(),
  direction: tradeDirectionSchema,
  status: tradeStatusSchema,
  openedAt: firestoreTimestampSchema,
  closedAt: firestoreTimestampSchema.optional(),
  createdAt: firestoreTimestampSchema,
  tags: z.array(z.string()).default([]),
  message: tradeMessageWriteSchema.optional(),
});

export type TradeWrite = z.infer<typeof tradeWriteSchema>;
